import React, { useState, useRef } from 'react';
import PatientSearch from 'components/Patient/PatientSearch';
import PatientUtils from 'services/PatientUtils';
import DefaultButton from 'components/Utils/NewDefaultButton';
import RouteUtils from 'services/RouteUtils';
import { PatientImage } from 'components/Common/UserImage';
import './style.scss';
import DefaultModal from 'components/Utils/DefaultModal';
import StaffRegisterPatient from 'components/Patient/StaffRegisterPatient';
import { useAppSelector } from 'careand-redux/store';
import { FavoritePatientButton } from 'components/Physician/PhysicianPatients';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import GenericDirectory from 'components/Directories/GenericDirectory';
import ResponsiveColumns from 'components/ResponsiveColumns';

const PatientSearchScreen = () => {
  const nav = useNavStack(Stacks.Master);
  const [clickedPatient, setClickedPatient] = useState();
  const [newPatientModal, setNewPatientModal] = useState(false);
  const navigateTo = useRef();

  function onSelectedPatient(patient) {
    setClickedPatient(patient);
    setTimeout(() => {
      navigateTo.current?.(1);
    });
  }

  const role = useAppSelector((state) => state.authentication.role);

  function viewProfile(patient) {
    let route = RouteUtils.getCPPRoute(patient.id);
    nav.push(route);
  }

  function onClickRegister() {
    setNewPatientModal(true);
  }

  function onCloseModal() {
    setNewPatientModal(false);
  }

  function onRegisterSuccess(patient) {
    let route = RouteUtils.getRoute(RouteUtils.routes().patient, {
      ':patientId': patient.id,
    });
    nav.push(route);
  }

  return (
    <GenericDirectory
      title="Patients"
      className="patient-search-screen"
      showTopRowMobile
      topRowContent={
        role === 'admin' && (
          <DefaultButton
            name="Register New Patient"
            onClick={onClickRegister}
            style={{ width: '200px' }}
            className="new-patient-button white"
          />
        )
      }
    >
      {newPatientModal && (
        <DefaultModal
          className="modal staff-register-patient-modal"
          title="Register Patient"
          wrap={true}
          padding={true}
          content={<StaffRegisterPatient onSuccess={onRegisterSuccess} />}
          isOpen={newPatientModal}
          onRequestClose={onCloseModal}
        />
      )}
      <ResponsiveColumns
        navigateTo={navigateTo}
        columns={[
          {
            name: 'Search',
            element: (
              <PatientSearch onSelect={onSelectedPatient} showRecent={true} showFavorites={true} />
            ),
          },
          (clickedPatient && {
            name: 'Patient',
            element: <PatientInformation patient={clickedPatient} onViewProfile={viewProfile} />,
          }) ||
            undefined,
        ]}
      />
    </GenericDirectory>
  );
};

export const PatientInformation = ({ patient, onViewProfile }) => {
  const role = useAppSelector((state) => state.authentication.role);
  const isPhysician = role === 'physician';

  return (
    <div className="profile-column">
      <div className="user-information">
        <span className="name">{PatientUtils.getName(patient)}</span>
        <div className="photo-wrapper">
          <PatientImage user={patient} size={100} />
        </div>
        <div className="bottom-information">
          <span className="gender-age">
            {PatientUtils.getGender(patient)} - {PatientUtils.getBirthdate(patient)}
          </span>
          <span className="ohip">OHIP: {PatientUtils.getOhipNumber(patient)}</span>
        </div>
        <div className="column button-wrapper">
          <DefaultButton
            className="blue"
            name="View Profile"
            onClick={() => onViewProfile(patient)}
            style={{ width: '250px' }}
          />
          {isPhysician && <FavoritePatientButton patient={patient} />}
        </div>
      </div>
    </div>
  );
};

export default PatientSearchScreen;
